module.exports = __webpack_public_path__ + "static/media/icon-supplies-licecomb.3d308b58.svg";